import { render, staticRenderFns } from "./GogoRuntimeRouterView.vue?vue&type=template&id=6e37928a"
import script from "./GogoRuntimeRouterView.vue?vue&type=script&lang=ts"
export * from "./GogoRuntimeRouterView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports